import { hasFeature } from '../../core/FeatureFlag/FeatureFlag';
import { Locale } from '../../core/i18n/Locale';
import { User } from '../../resources/user/domain/types/User';
import { PickDomain } from '../utilities/types/PickDomain';

export function showLoyaltyProgram(
    user: PickDomain<
        User,
        'locale' | 'numberOfUserQuotesByStateCounters',
        {
            status: User['status'] | null;
        }
    >,
    locale: Locale,
) {
    const isUserEligible =
        (user.status === 'first timer experiencer' ||
            user.status === 'repeater experiencer' ||
            (user.status === 'wanderlust' &&
                user.locale === 'fr-FR' &&
                user.numberOfUserQuotesByStateCounters.confirmed > 0)) &&
        (user.locale === 'fr-FR' || user.locale === 'de-DE');

    return isUserEligible && hasFeature('loyalty_program', locale);
}
